var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "register-wrapper __form_border" }, [
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "item" },
        [
          _c("div", { staticClass: "__form_input_title" }, [
            _vm._v(
              "\n                " +
                _vm._s(_vm.$t("walletSBP.section1.nodeName")) +
                "\n                "
            ),
            _c(
              "span",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.nodeNameErr,
                    expression: "nodeNameErr"
                  }
                ],
                staticClass: "err"
              },
              [_vm._v(_vm._s(_vm.nodeNameErr))]
            )
          ]),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "__form_tips",
              class: { active: _vm.tipsType === "name" }
            },
            [
              _vm._v(
                "\n                " +
                  _vm._s(
                    _vm.tipsType === "name"
                      ? _vm.$t("walletSBP.section1.nameHint")
                      : ""
                  ) +
                  "\n            "
              )
            ]
          ),
          _vm._v(" "),
          _c("vite-input", {
            attrs: {
              valid: _vm.testName,
              placeholder: _vm.$t("walletSBP.section1.namePlaceholder")
            },
            on: {
              blur: _vm.hideTips,
              focus: function($event) {
                return _vm.showTips("name")
              }
            },
            model: {
              value: _vm.nodeName,
              callback: function($$v) {
                _vm.nodeName = $$v
              },
              expression: "nodeName"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "item" },
        [
          _c("div", { staticClass: "__form_input_title" }, [
            _vm._v(
              "\n                " +
                _vm._s(_vm.$t("walletSBP.section1.producerAddr")) +
                "\n                "
            ),
            _c(
              "span",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.producerAddrErr,
                    expression: "producerAddrErr"
                  }
                ],
                staticClass: "err"
              },
              [_vm._v(_vm._s(_vm.producerAddrErr))]
            )
          ]),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "__form_tips",
              class: { active: _vm.tipsType === "addr" }
            },
            [
              _vm._v(
                "\n                " +
                  _vm._s(
                    _vm.tipsType === "addr"
                      ? _vm.$t("walletSBP.section1.addrHint")
                      : ""
                  ) +
                  "\n            "
              )
            ]
          ),
          _vm._v(" "),
          _c("vite-input", {
            attrs: {
              valid: _vm.testAddr,
              placeholder: _vm.$t("walletSBP.section1.addrPlaceholder")
            },
            on: {
              blur: _vm.hideTips,
              focus: function($event) {
                return _vm.showTips("addr")
              }
            },
            model: {
              value: _vm.producerAddr,
              callback: function($$v) {
                _vm.producerAddr = $$v
              },
              expression: "producerAddr"
            }
          })
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "item" }, [
        _c("div", { staticClass: "__form_input_title" }, [
          _vm._v(_vm._s(_vm.$t("walletSBP.section1.quotaAddr")))
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "__form_input all unuse __ellipsis" }, [
          _vm._v(_vm._s(_vm.quotaAddr))
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "item" }, [
        _c("div", { staticClass: "__form_input_title" }, [
          _vm._v(_vm._s(_vm.$t("walletSBP.section1.quotaTime")))
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "__form_input all unuse __ellipsis" }, [
          _vm._v(_vm._s(_vm.$t("walletSBP.section1.time")))
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "item" }, [
        _c("div", { staticClass: "__form_input_title" }, [
          _vm._v(
            "\n                " +
              _vm._s(_vm.$t("stakingAmount")) +
              "\n                "
          ),
          _c(
            "span",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.amountErr,
                  expression: "amountErr"
                }
              ],
              staticClass: "err"
            },
            [_vm._v(_vm._s(_vm.amountErr))]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "__form_input all unuse __ellipsis" }, [
          _vm._v("1,000,000 dSLS")
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "item" }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.btnUnuse,
                expression: "!btnUnuse"
              }
            ],
            staticClass: "__form_btn __pointer",
            class: {
              unuse: _vm.btnUnuse
            },
            on: { click: _vm._validTx }
          },
          [_vm._v(_vm._s(_vm.$t("walletSBP.section1.confirmBtn")))]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.btnUnuse,
                expression: "btnUnuse"
              }
            ],
            staticClass: "__form_btn __pointer",
            class: {
              unuse: _vm.btnUnuse
            }
          },
          [_vm._v(_vm._s(_vm.$t("walletSBP.section1.confirmBtn")))]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }